export default __webpack_public_path__ + "static/media/(26).f57e0aa3.jpeg";